import React from 'react';

/* There will likely be more contexts in the future, so don't complain about
   only exporting a single named thing */
/* eslint-disable-next-line import/prefer-default-export */
export const ErrorFocusContext = React.createContext('errorFocus');
